export class ReviewDetailsBase {
    tdc: string = '';
    gm: string = '';
    status: string = '';
    approvedSellPrice: number = 0;
    installType: string = '';
    trrStatus: string = '';
    business: string = '';
    estimateSubSegmentType: number = 0;
    estimateID: string = '';
    originalReviewerID: string = '';
}